import { render, staticRenderFns } from "./JdhFieldStructure.vue?vue&type=template&id=2fa6228c&scoped=true&"
import script from "./JdhFieldStructure.vue?vue&type=script&lang=ts&"
export * from "./JdhFieldStructure.vue?vue&type=script&lang=ts&"
import style0 from "./JdhFieldStructure.vue?vue&type=style&index=0&id=2fa6228c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa6228c",
  null
  
)

export default component.exports